import { getDynamicLabelValues } from '../labels/labelUtilty';

const errorMessageKeys = [
  'lbl_err_addressline1_address',
  'lbl_err_addressline1_maxlength',
  'lbl_err_addressline2_address',
  'lbl_err_airmilesaccountnumber',
  'lbl_err_associateid',
  'lbl_err_birthdate',
  'lbl_err_cardnumber_plccenabled',
  'lbl_err_cardnumber_required',
  'lbl_err_cardnumber_type',
  'lbl_err_cardnumber_non_cc',
  'lbl_err_cardnumber_non_plcc',
  'lbl_err_cardpin',
  'lbl_err_city_city',
  'lbl_err_city_nonempty',
  'lbl_err_country_required',
  'lbl_err_currentpassword_equalto',
  'lbl_err_currentpassword_password',
  'lbl_err_date_dob',
  'lbl_err_dob_required',
  'lbl_err_email',
  'lbl_err_email_req',
  'lbl_err_firstname_maxlength',
  'lbl_err_firstname_name',
  'lbl_err_firstname_nonempty',
  'lbl_err_name_nonempty',
  'lbl_err_name_name',
  'lbl_err_name_maxlength',
  'lbl_err_gender_required',
  'lbl_err_accept_tna_required',
  'lbl_err_userbirthdaymonth_required',
  'lbl_err_userbirthdayyear_required',
  'lbl_err_giftcardnumber',
  'lbl_err_iagree',
  'lbl_err_lastname_maxlength',
  'lbl_err_lastname_name',
  'lbl_err_lastname_nonempty',
  'lbl_err_month_dob',
  'lbl_err_ordernumber',
  'lbl_err_password_password',
  'lbl_err_password_required',
  'lbl_err_phonenumber_phone',
  'lbl_err_phonenumber_required',
  'lbl_err_prescreencode',
  'lbl_err_recaptchatoken_required',
  'lbl_err_req',
  'lbl_err_ssnumber_ssn',
  'lbl_err_statewocountry_required',
  'lbl_err_validexpirationedate',
  'lbl_err_expMonth',
  'lbl_err_expYear',
  'lbl_err_validstreetaddress',
  'lbl_err_year_dob',
  'lbl_err_zipcode_required',
  'lbl_err_zipcode_zipcode',
  'lbl_err_email_validemail',
  'lbl_err_state_staterequired_us',
  'lbl_err_state_staterequired_nonus',
  'lbl_err_altphonenumber_notequalto',
  'lbl_err_emailaddressnoasync',
  'lbl_err_cvvcode_required',
  'lbl_err_cvvcode_cvvnumber',
  'lbl_err_cvvcode_cvvlengththree',
  'lbl_err_cvvcode_cvvlengthfour',
  'lbl_storelanding_errorLabel',
  'lbl_storelanding_validErrorLabel',
  'lbl_storelanding_invalidAddressError',
  'lbl_fav_list_name_nonempty',
  'lbl_credit_card_valid',
  'lbl_err_age_required',
  'lbl_err_age_gate',
  'lbl_err_email_required',
  'lbl_err_password_notEqualto',
];

const formErrorCMSMessage = errorMessageKeys.reduce((acc, key) => {
  acc[key] = getDynamicLabelValues(`dynamic.error_messages.${key}`);
  return acc;
}, {});

export default formErrorCMSMessage;
